// src/utils/reportsParser.js

/** Pallet rows: name in col 0, images in cols 1, 3, 5, 7 (sheet layout). */
export const parseReportsPallets = (rows) => {
  return rows
    .filter(row => String(row[0] || '').trim())
    .map((row, index) => ({
      id: index + 1,
      name: row[0] || `Pallet ${index + 1}`,
      images: [
        row[1] || '',
        row[3] || '',
        row[5] || '',
        row[7] || '',
      ],
    }));
};
